// @ts-ignore - no types for webtonative/Firebase/Messaging
import { getFCMToken as getWtnFCMToken, subscribe as wtnSubscribe, unsubscribe as wtnUnsubscribe } from 'webtonative/Firebase/Messaging';

/**
 * Gets the FCM token for the current device via WebToNative.
 * Returns null if not in a browser environment, or if the callback fails or returns no token.
 *
 * @returns Promise<string | null> - The FCM token or null if unavailable
 */
export const getFCMToken = (): Promise<string | null> => {
  if (typeof window === 'undefined') {
    return Promise.resolve(null);
  }

  return new Promise((resolve) => {
    try {
      getWtnFCMToken({
        callback: (data: { token?: string }) => {
          resolve(data?.token ?? null);
        },
      });
    } catch {
      resolve(null);
    }
  });
};

/**
 * Subscribes the device to an FCM topic via WebToNative.
 * Topic names must match [a-zA-Z0-9-_.~%]+. No-op when not in browser.
 */
export const subscribeToTopic = (topic: string): void => {
  if (typeof window === 'undefined' || !topic) return;
  try {
    wtnSubscribe({ toTopic: topic });
  } catch (error) {
    console.warn('[FCM] subscribeToTopic failed:', error);
  }
};

/**
 * Unsubscribes the device from an FCM topic via WebToNative.
 * No-op when not in browser.
 */
export const unsubscribeFromTopic = (topic: string): void => {
  if (typeof window === 'undefined' || !topic) return;
  try {
    wtnUnsubscribe({ fromTopic: topic });
  } catch (error) {
    console.warn('[FCM] unsubscribeFromTopic failed:', error);
  }
};
